module.exports = __webpack_public_path__ + "e70391ca06f7587ecf3ac8ddfec7a192.MP3";